import React, { useEffect, useState, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const PremiumAboutUs = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeGalleryIndex, setActiveGalleryIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  // Luxury hotel gallery images
  const galleryImages = [
    "https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/DRONE/DJI_0213.JPG?updatedAt=1747392643114",
    "https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/PROPERTY%20SHOOT/02/0N2A6027.JPG?updatedAt=1747391842046",
    "https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/PROPERTY%20SHOOT/02/0N2A5942.JPG?updatedAt=1747392407802",
    "https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/PROPERTY%20SHOOT/02/0N2A5840.JPG?updatedAt=1747391958201",
  ];

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: false,
      mirror: true,
      easing: "cubic-bezier(0.19, 1, 0.22, 1)",
      anchorPlacement: "center-bottom",
    });

    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Gallery rotation
    const galleryInterval = setInterval(() => {
      setActiveGalleryIndex(
        (prevIndex) => (prevIndex + 1) % galleryImages.length
      );
    }, 5000);

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(galleryInterval);
    };
  }, [galleryImages.length]);

  const toggleVideo = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  useEffect(() => {
    AOS.init({
      once: true, // Only animate once
      duration: 1000,
      offset: 50,
    });
  }, []);

  return (
    <div className="bg-black text-white font-serif">
      {/* Luxury Navigation */}

      {/* Hero Section with Video and Gold Accents */}
      <div className="relative h-screen overflow-hidden">
        <div className="absolute inset-0 bg-black/60 z-10"></div>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${galleryImages[activeGalleryIndex]})`,
            transition: "all 1.5s cubic-bezier(0.7, 0, 0.3, 1)",
          }}
        ></div>

        {/* Animated Gold Line Pattern Overlay */}
        <div className="absolute inset-0 z-20 opacity-20">
          <div className="absolute left-0 top-0 w-1/3 h-px bg-amber-300"></div>
          <div className="absolute right-0 top-0 w-1/3 h-px bg-amber-300"></div>
          <div className="absolute left-0 bottom-0 w-1/3 h-px bg-amber-300"></div>
          <div className="absolute right-0 bottom-0 w-1/3 h-px bg-amber-300"></div>
          <div className="absolute left-0 top-0 w-px h-1/3 bg-amber-300"></div>
          <div className="absolute right-0 top-0 w-px h-1/3 bg-amber-300"></div>
          <div className="absolute left-0 bottom-0 w-px h-1/3 bg-amber-300"></div>
          <div className="absolute right-0 bottom-0 w-px h-1/3 bg-amber-300"></div>
        </div>

        <div className="absolute inset-0 z-30 flex flex-col items-center justify-center px-6 text-center mt-28">
          <div data-aos="fade-down" data-aos-duration="2000" className="mb-12">
            <div className="relative inline-block">
              <div className="absolute -top-8 -left-8 w-6 h-6 border-l-2 border-t-2 border-amber-400"></div>
              <div className="absolute -top-8 -right-8 w-6 h-6 border-r-2 border-t-2 border-amber-400"></div>
              <div className="absolute -bottom-8 -left-8 w-6 h-6 border-l-2 border-b-2 border-amber-400"></div>
              <div className="absolute -bottom-8 -right-8 w-6 h-6 border-r-2 border-b-2 border-amber-400"></div>
              <img
                src="https://ik.imagekit.io/tdlebsr5e/TheGulmoharGrand.jpeg?updatedAt=1750152666297"
                alt="Gulmohar Grand  Logo"
                className="h-24 mx-auto"
              />
            </div>
          </div>

          <h1
            data-aos="fade-up"
            data-aos-duration="2000"
            className="text-5xl md:text-7xl font-extralight tracking-wider leading-tight mb-6"
          >
            <span className="block text-xl tracking-widest mb-4 text-amber-300">
              SINCE 2019
            </span>
            OUR LEGACY OF <br />
            <span className="text-amber-300">EXCELLENCE</span>
          </h1>

          <p
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="2000"
            className="text-xl font-light max-w-2xl mx-auto mb-10 opacity-90"
          >
            Immerse yourself in the timeless elegance of <a
              href="https://devbhoomigroup.in"
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:underline"
            >
              Dev Bhoomi Group Companies
            </a>

            crown jewel in Himachal Pradesh
          </p>
        </div>

        {/* Gallery Navigation */}
        <div className="absolute bottom-8 right-8 z-30">
          <div className="flex space-x-3">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveGalleryIndex(index)}
                className={`w-12 h-px ${index === activeGalleryIndex
                  ? "bg-amber-400"
                  : "bg-white opacity-50"
                  } transition-all duration-300`}
              ></button>
            ))}
          </div>
        </div>
      </div>

      {/* Video Modal (Hidden by default) */}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black/90 transition-opacity duration-500 ${isPlaying ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
      >
        <button
          onClick={toggleVideo}
          className="absolute top-8 right-8 text-white opacity-70 hover:opacity-100 transition-opacity duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="w-full max-w-4xl">
          <video
            ref={videoRef}
            className="w-full"
            controls={false}
            onEnded={() => setIsPlaying(false)}
          >
            <source src="/api/placeholder/400/320" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* About Section with Elegant Layout */}
      <div className="py-32 relative">
        <div className="absolute left-0 top-0 w-1/4 h-px bg-amber-600 opacity-20"></div>
        <div className="absolute right-0 bottom-0 w-1/4 h-px bg-amber-600 opacity-20"></div>

        <div className="container mx-auto px-8">
          <div className="flex flex-col lg:flex-row items-center">
            <div
              className="w-full lg:w-2/5 mb-16 lg:mb-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="relative">
                <span className="absolute -top-8 left-0 text-xs tracking-widest text-amber-300 font-light">
                  ABOUT US
                </span>

                <h2 className="text-4xl font-light leading-tight mb-8">
                  A Legacy of <br />
                  <span className="text-amber-300">Unparalleled Luxury</span>
                </h2>

                <div className="h-px w-16 bg-amber-400 mb-10"></div>

                <p className="text-slate-300 font-light leading-relaxed text-lg mb-10">
                  An esteemed and well-known name in the corporate domains of
                  Himachal Pradesh, we carry a legacy of enhancing our customers
                  with products and services par excellence since 2005.
                </p>

                <p className="text-slate-300 font-light leading-relaxed text-lg mb-12">
                  <a
                    href="https://devbhoomigroup.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" hover:underline"
                  >
                    Dev Bhoomi Group Companies
                  </a>
                  operate in different verticals,
                  such as automobiles, steel, hotels, and beyond. With an
                  employee strength of more than 400 professionals, Dev Bhoomi
                  Group is committed to extending an elite and superlative
                  experience to its customers in terms of consumer services and
                  value for money.
                </p>

                <div className="flex space-x-8">
                  <div className="text-center">
                    <span className="block text-4xl font-light text-amber-300 mb-2">
                      2005
                    </span>
                    <span className="text-xs tracking-widest text-slate-300">
                      ESTABLISHED
                    </span>
                  </div>

                  <div className="text-center">
                    <span className="block text-4xl font-light text-amber-300 mb-2">
                      400+
                    </span>
                    <span className="text-xs tracking-widest text-slate-300">
                      PROFESSIONALS
                    </span>
                  </div>

                  <div className="text-center">
                    <span className="block text-4xl font-light text-amber-300 mb-2">
                      2019
                    </span>
                    <span className="text-xs tracking-widest text-slate-300">
                      HOTEL LAUNCH
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="w-full lg:w-3/5 lg:pl-20"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="relative">
                <div className="grid grid-cols-2 gap-4 w-full min-w-0">
                  {[
                    "https://ik.imagekit.io/tdlebsr5e/0N2A5857.JPG?updatedAt=1747388903201",
                    "https://ik.imagekit.io/tdlebsr5e/0N2A5821.JPG?updatedAt=1747388905177",
                    "https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/FINAL%20EDITED%20GULMOHAR/0N2A6029.JPG?updatedAt=1747392838628",
                  ].map((src, idx) => (
                    <div
                      key={idx}
                      className="aspect-[1/1] overflow-hidden w-full min-h-0"
                    >
                      <img
                        src={src}
                        alt="Luxury Hotel"
                        className="w-full h-full object-cover transition-transform duration-1000 hover:scale-110"
                      />
                    </div>
                  ))}

                  <div className="aspect-[1/1] overflow-hidden relative group w-full min-h-0">
                    <img
                      src="https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/PROPERTY%20SHOOT/01/0N2A9969.JPG?updatedAt=1747391362256"
                      alt="Luxury Hotel"
                      className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                    />
                    <Link to="/gallery">
                      <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-60 transition-opacity duration-500 flex items-center justify-center cursor-pointer">
                        <span className="text-amber-300 text-sm tracking-widest font-light">
                          VIEW GALLERY
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="absolute -bottom-8 -right-8 w-40 h-40 border border-amber-400 opacity-20"></div>
                <div className="absolute -top-8 -left-8 w-40 h-40 border border-amber-400 opacity-20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal (Hidden by default) */}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center bg-black/90 transition-opacity duration-500 ${isPlaying ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
      >
        <button
          onClick={toggleVideo}
          className="absolute top-8 right-8 text-white opacity-70 hover:opacity-100 transition-opacity duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="w-full max-w-4xl">
          <video
            ref={videoRef}
            className="w-full"
            controls={false}
            onEnded={() => setIsPlaying(false)}
          >
            <source src="/api/placeholder/400/320" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      {/* About Section with Elegant Layout */}
      <div className=" relative">
        <div className="absolute left-0 top-0 w-1/4 h-px bg-amber-600 opacity-20"></div>
        <div className="absolute right-0 bottom-0 w-1/4 h-px bg-amber-600 opacity-20"></div>

        {/* Timeline Journey Section */}
        <div className="py-16 bg-black relative">
          <div className="container mx-auto px-8">
            <div className="text-center mb-20">
              <span className="text-xs tracking-widest text-amber-300 font-light">
                OUR JOURNEY
              </span>
              <h2 className="text-4xl font-light mt-4 mb-6">The Path to Excellence</h2>
              <div className="h-px w-16 bg-amber-400 mx-auto"></div>
            </div>

            <div className="relative max-w-6xl mx-auto">
              {/* Timeline Center Line */}
              <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-px bg-slate-800"></div>

              {/* Timeline Items */}
              <div className="relative z-10 space-y-20">
                {/* Timeline Entry Template */}
                {[
                  {
                    year: "2005",
                    title: "Foundation",
                    description:
                      "Rajinder Vashista established Dev Bhoomi Group, beginning with iron rod trading and real estate operations in Himachal Pradesh.",
                    align: "left",
                  },
                  {
                    year: "2011",
                    title: "Automotive Expansion",
                    description:
                      "Entered the automobile industry with a SKODA authorized dealership in Mandi, Himachal Pradesh.",
                    align: "right",
                  },
                  {
                    year: "2014",
                    title: "Hyundai Partnership",
                    description:
                      "Became the authorized dealer of Hyundai Motors India Ltd, marking a significant expansion in the automotive sector.",
                    align: "left",
                  },
                  {
                    year: "2019",
                    title: "Hospitality Sector",
                    description:
                      "In 2019, the business entered the hospitality industry with the launch of The Gulmohar Grand, a premier hotel aimed at providing high-quality accommodation and services to both business and leisure travelers.",
                    align: "right",
                  },
                  {
                    year: "2019",
                    title: "Entertainment Sector",
                    description:
                      "The group ventured into the entertainment industry by launching Grand Cinemaz — a modern cinema experience offering the latest movies, premium comfort, and state-of-the-art screening facilities to audiences.",
                    align: "left",
                  },
                  {
                    year: "2020",
                    title: "Standing Together During the Pandemic",
                    description:
                      "Amid the global COVID-19 crisis, we stood firmly with our team. Every employee received full salary without a single deduction, even while safely at home — upholding our values of trust, care, and unity.",
                    align: "right",
                  },
                  {
                    year: "2021",
                    title: "SKODA Expansion",
                    description:
                      "Opened a new SKODA dealership in Solan, strengthening the automotive business vertical.",
                    align: "left",
                  },
                  {
                    year: "2025",
                    title: "Venturing into Clean Energy",
                    description:
                      "In 2025, the business ventured into the renewable energy sector with the launch of FDL Solar, offering sustainable solar energy solutions for homes, businesses, and industries.",
                    align: "right",
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex flex-col md:flex-row items-center">
                    {item.align === "left" ? (
                      <>
                        <div
                          data-aos="fade-right"
                          className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-12 text-right"
                        >
                          <h3 className="text-3xl font-light text-amber-300 mb-4">
                            {item.year}
                          </h3>
                          <h4 className="text-xl font-light mb-3">{item.title}</h4>
                          <p className="text-slate-300 font-light">{item.description}</p>
                        </div>
                        <div className="absolute left-1/2 transform -translate-x-1/2 w-5 h-5 bg-amber-400"></div>
                        <div className="w-full md:w-1/2 md:pl-12"></div>
                      </>
                    ) : (
                      <>
                        <div className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-12"></div>
                        <div className="absolute left-1/2 transform -translate-x-1/2 w-5 h-5 bg-amber-400"></div>
                        <div
                          data-aos="fade-right"
                          className="w-full md:w-1/2 md:pl-12"
                        >
                          <h3 className="text-3xl font-light text-amber-300 mb-4">
                            {item.year}
                          </h3>
                          <h4 className="text-xl font-light mb-3">{item.title}</h4>
                          <p className="text-slate-300 font-light">{item.description}</p>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Call to Action */}
      <div
        className="relative py-32 bg-fixed bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://ik.imagekit.io/tdlebsr5e/GULMOHAR%20SHOOT/PICTURES/PROPERTY%20SHOOT/02/0N2A6047.JPG?updatedAt=1747392487065')",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-70"></div>

        <div className="relative z-10 container mx-auto px-8 text-center">
          <h2
            data-aos="fade-up"
            className="text-4xl md:text-5xl font-light mb-8 max-w-4xl mx-auto"
          >
            Experience Unparalleled Luxury at
            <span className="text-amber-300"> Gulmohar Grand</span>
          </h2>

          <p
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-xl font-light mb-12 max-w-3xl mx-auto text-slate-200"
          >
            We invite you to indulge in the pinnacle of hospitality at our
            luxurious 5-star property in Una, Himachal Pradesh.
          </p>

          {/* <div
            data-aos="fade-up"
            data-aos-delay="200"
            className="flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-8"
          >
            <button className="bg-amber-400 text-black hover:bg-amber-300 text-sm tracking-widest py-4 px-10 transition-all duration-300">
              BOOK YOUR STAY
            </button>

            <button className="border border-white text-white hover:border-amber-400 hover:text-amber-300 text-sm tracking-widest py-4 px-10 transition-all duration-300">
              EXPLORE OUR ROOMS
            </button>
          </div> */}
        </div>
      </div>

      {/* The Visionary Founder Section */}
      <div className="py-16 bg-black relative">
        <div className="absolute left-0 top-0 w-1/4 h-px bg-amber-600 opacity-20"></div>
        <div className="absolute right-0 bottom-0 w-1/4 h-px bg-amber-600 opacity-20"></div>

        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <span className="text-xs tracking-widest text-amber-300 font-light">
              THE VISIONARY
            </span>
            <h2 className="text-4xl font-light mt-4 mb-6">Our Founder & Chairman</h2>
            <div className="h-px w-16 bg-amber-400 mx-auto"></div>
          </div>

          <div className="flex flex-col items-center justify-center">
            {/* Image and Title - Top Section */}
            <div
              className="w-full max-w-4xl mx-auto mb-16 relative"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <div className="absolute -top-8 -left-8 w-40 h-40 border border-amber-400 opacity-20"></div>
              <div className="absolute -bottom-8 -right-8 w-40 h-40 border border-amber-400 opacity-20"></div>

              {/* Founder Image - Smaller and Top Centered */}
              <div
                className="w-60 h-full rounded-full overflow-hidden  border-amber-400 mx-auto mb-6"
                data-aos="fade-down"
                data-aos-duration="1200"
              >
                <img
                  src="https://ik.imagekit.io/zfayt6inj/06A0803B-521A-4652-8304-32684BA0BCB5_4_5005_c.jpeg?updatedAt=1747409890168"
                  alt="Shri Rajinder Vashista"
                  className="w-full h-full object-cover"
                />
              </div>

            </div>

            {/* Profile and Stats - Below Image */}
            <div
              className="w-full max-w-4xl mx-auto mb-16 bg-slate-900/50 p-8 border-l-2 border-amber-400"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                <div className="flex items-center">
                  <div className="w-16 h-16 rounded-full bg-black border border-amber-400 flex items-center justify-center mr-6">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-amber-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                  </div>

                  <div>
                    <h4 className="text-2xl font-light mb-1">
                      Mr. Rajinder Vashista
                    </h4>
                    <p className="text-amber-300 font-light tracking-wide">
                      Chairman & Managing Director
                    </p>
                  </div>
                </div>

                <div className="flex justify-center gap-8 md:gap-12">
                  <div className="text-center">
                    <span className="block text-3xl font-light text-amber-300 mb-2">
                      20+
                    </span>
                    <span className="text-xs tracking-widest text-slate-400">
                      YEARS EXPERIENCE
                    </span>
                  </div>

                  <div className="text-center">
                    <span className="block text-3xl font-light text-amber-300 mb-2">
                      4
                    </span>
                    <span className="text-xs tracking-widest text-slate-400">
                      BUSINESS VERTICALS
                    </span>
                  </div>

                  <div className="text-center">
                    <span className="block text-3xl font-light text-amber-300 mb-2">
                      400+
                    </span>
                    <span className="text-xs tracking-widest text-slate-400">
                      PROFESSIONALS
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Text Section */}
            <div
              className="w-full max-w-4xl mx-auto"
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <h2 className="text-4xl font-light leading-tight mb-8">
                Mr. Rajinder Vashista
              </h2>

              <div className="h-px w-16 bg-amber-400 mb-10"></div>

              <p className="text-slate-300 font-light leading-relaxed text-lg mb-8">
                Rajinder Vashista, began his entrepreneurial venture as an Iron
                steel Trader, and he realised it was not the time to rest on his
                laurels in instead, he made an informed decision to enter the
                Automobiles business in 2011 with a SKODA authorized dealership
                in Mandi (Himachal Pradesh) and Solan (Himachal Pradesh) in the
                year 2021.
              </p>

              <p className="text-slate-300 font-light leading-relaxed text-lg mb-8">
                The sole driving force behind <a
                  href="https://devbhoomigroup.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" hover:underline"
                >
                  Dev Bhoomi Group Companies
                </a>
                ,
                Rajinder Vashista with his vast experience and thought-provoking
                approaches, has established an involvement in yet another highly
                versatile industry: the hospitality and management industry. One
                of his most recent ventures, a luxurious hotel "The Gulmohar
                Grand", promises to be one of the most prominent of all.
              </p>

              <p className="text-slate-300 font-light leading-relaxed text-lg mb-10">
                Rajinder Vashista perceives it as a mission to deliver the most
                commendable and satisfying experience to its customers while
                providing wealth to the province. He built an empire of
                approximately 5lac Sq. feet on his own fitted with
                best-in-class services with all the showrooms outfitted with
                cutting-edge infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PremiumAboutUs;
